import { SxProps } from "@mui/material";

export const tableContainer: SxProps = {
  width: "auto",
  backgroundColor: "#fff",
  borderRadius: "5px",
  border: "1px solid rgba(200, 200, 200, 1)",
};
export const dotwHeader: SxProps = { fontWeight: "bold" };
